<template>
    <div class="position-box currencyTrading contractOrder">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('bzhl.dd')}}</div>
            <img class="search" @click="select" src="@/assets/new/screen.png" alt="">
        </div>
        <div class="tab-wrap">
          <ul class="tab-box">
            <li class="tab" :class="{active: tabIdx == 0}" @click="tab(0)">
              <div class="text">{{$t('hyjy.cc')}}</div>
            </li>
            <li class="tab tab2" :class="{active: tabIdx == 1}" @click="tab(1)">
              <div class="text">{{$t('langNew.gd')}}</div>
            </li>
            <li class="tab tab3" :class="{active: tabIdx == 2}" @click="tab(2)">
              <div class="text">{{$t('deals.pied')}}</div>
            </li>
          </ul>
        </div>
        <div class="cotainer" @scroll="listenScroll">
          <!-- 持仓 -->
          <ul class="item-box">
            <li class="item-li"  v-for="(item,index) in positionList" :key="index" @click.stop="look(item)">
              <div class="li-head">
                  <div v-if="tabIdx == 0"><span class="title">{{item.currency | rewriteName}}</span><span class="bei" v-if="item.type == 1">{{$t('kxt.mr')}} {{item.position_a}}</span><span class="bei" v-if="item.type == 2">{{$t('kxt.mc')}} {{item.position_a}}</span></div>
                  <div v-else-if="tabIdx == 2"><span class="title">{{item.currency | rewriteName}}</span><span class="bei" v-if="item.type == 4">{{$t('kxt.mr')}} {{item.lot_num}}</span><span class="bei" v-if="item.type == 3">{{$t('kxt.mc')}} {{item.lot_num}}</span></div>
                  <div v-else><span class="title">{{item.currency | rewriteName}}</span><span class="bei" v-if="item.mark == 1">{{$t('kxt.mr')}} {{item.amount}}</span><span class="bei" v-if="item.mark == 2">{{$t('kxt.mc')}} {{item.amount}}</span></div>
                  <div class="btn-pc" @click.stop="pingcang(item)" v-show="tabIdx == 0">{{$t('hyjy.pc')}}</div>
                  <div class="btn-pc" @click.stop="cancelOrder(item.id)" v-show="tabIdx == 1 && item.status == 0">{{$t('hyjy.cd')}}</div>
                </div>
                <ul class="ul-box">
                  <li class="li li-lt">
                    <div class="t2">
                      <div class="p1" v-if="tabIdx != 1">
                        <div class="money">{{item.open_price}}</div>
                        <div class="text">{{$t('hyjy.kcjg')}}</div>
                      </div>
                      <div class="p1" v-else>
                        <div class="money">{{item.price}}</div>
                        <div class="text">{{$t('langNew.gdjg')}}</div>
                      </div>
                      <img class="icon" v-if="!theme" src="@/assets/new/jiantou_xiangyou.png" alt="">
                      <img class="icon" v-else src="@/assets/new/theme/jiantou_xiangyou_white.png" alt="">
                      <div class="p1" v-if="tabIdx != 2">
                        <div class="money" v-if="item.cur_price == 0">{{item.new_price}}</div>
                        <div class="money" v-else>{{item.cur_price}}</div>
                        <div class="text">{{$t('langNew.dqjg')}}</div>
                      </div>
                      <div class="p1" v-if="tabIdx == 2">
                        <div class="money">{{item.close_out_price}}</div>
                        <div class="text">{{$t('langNew.pcjg')}}</div>
                      </div>
                    </div>
                  </li>
                  <li class="li" v-show="tabIdx != 1">
                    <div class="t1 price" :class="{red: item.profit_loss < 0}"><span v-show="item.profit_loss > 0">+</span>{{item.profit_loss | toFixed4}}</div>
                  </li>
                </ul>
            </li>
            <!-- <li class="item-li">
              <div class="li-head">
                  <div><span class="title">BTC</span><span class="bei">买涨 0.5</span></div>
                  <div class="btn-pc" @click="pingcang()">{{$t('hyjy.pc')}}</div>
                </div>
                <ul class="ul-box">
                  <li class="li li-lt">
                    <div class="t2">
                      <div class="p1">
                        <div class="money">20996.6</div>
                        <div class="text">{{$t('hyjy.kcjg')}}</div>
                      </div>
                      <img class="icon" v-if="!theme" src="@/assets/new/jiantou_xiangyou.png" alt="">
                      <img class="icon" v-else src="@/assets/new/theme/jiantou_xiangyou_white.png" alt="">
                      <div class="p1">
                        <div class="money">20996.6</div>
                        <div class="text">{{$t('langNew.dqjg')}}</div>
                      </div>
                    </div>
                  </li>
                  <li class="li">
                    <div class="t1 price" >+60.76</div>
                  </li>
                </ul>
            </li> -->
          </ul>
          <!-- 暂无数据 -->
          <div class="null-box" v-show="isNoData">
            <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
            <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
            <p class="text">{{$t('zwsj.title')}}</p>
          </div>
        </div>
        <!-- 返回顶部 -->
        <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
        <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
        <div class="mask" v-show="isMask"></div>
        <div class="alert-select-box2" v-show="isDetail">
          <div class="title">
            <div class="title-head">
              <div class="text"></div>
            </div>
            <img class="close" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <ul class="select-ul">
            <!-- <li class="select">
              <div class="t1">{{$t('bzhlwdtg.ddh')}}</div>
              <div class="t2"><span>sdsdjkj</span></div>
            </li> -->
            <li class="select" v-show="tabIdx != 1">
              <div class="t1">{{$t('jghy.yk')}}</div>
              <div class="t2 price"><span v-show="pcCont.profit_loss > 0">+</span>{{pcCont.profit_loss | toFixed4}}</div>
            </li>
            <li class="select">
              <div class="t1">{{$t('jghy.jyfx')}}</div>
              <div class="t2" v-if="pcCont.type == 1 || pcCont.type == 4">{{$t('kxt.mr')}}</div>
              <div class="t2" v-else>{{$t('kxt.mc')}}</div>
            </li>
            <li class="select" v-show="tabIdx == 0">
              <div class="t1">{{$t('hyjy.ss')}}</div>
              <div class="t2">{{pcCont.position_a}}</div>
            </li>
            <li class="select" v-show="tabIdx == 2">
              <div class="t1">{{$t('hyjy.ss')}}</div>
              <div class="t2">{{pcCont.lot_num}}</div>
            </li>
            <li class="select">
              <div class="t1" v-show="tabIdx == 0">{{$t('hyjy.ccsl')}}</div>
              <div class="t1" v-show="tabIdx == 1">{{$t('langNew.gdsl')}}</div>
              <div class="t1" v-show="tabIdx == 2">{{$t('langNew.pcsl')}}</div>
              <div class="t2" >{{pcCont.amount}}</div>
            </li>
            <li class="select" v-show="tabIdx == 0">
              <div class="t1">{{$t('hyjy.ccjg')}}</div>
              <div class="t2">{{pcCont.position_price}}</div>
            </li>
            <li class="select" v-show="tabIdx == 2">
              <div class="t1">{{$t('langNew.pcjg')}}</div>
              <div class="t2">{{pcCont.close_out_price}}</div>
            </li>
            <li class="select" v-show="tabIdx != 1">
              <div class="t1">{{$t('hyjy.kcjg')}}</div>
              <div class="t2">{{pcCont.open_price}}</div>
            </li>
            <li class="select" v-show="tabIdx == 1">
              <div class="t1">{{$t('langNew.gdjg')}}</div>
              <div class="t2">{{pcCont.price}}</div>
            </li>
            <li class="select" @click="setZyzs(pcCont)" v-show="tabIdx == 0 && pcCont.stop_profit == 0">
              <div class="t1">{{$t('langNew.szzyzs')}}</div>
              <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
              <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
            </li>
            <li class="select" v-show="tabIdx == 0 && pcCont.stop_profit != 0">
              <div class="t1">{{$t('zyzs.zy')}}</div>
              <div class="t2">{{pcCont.stop_profit}}</div>
            </li>
             <li class="select" v-show="tabIdx == 0 && pcCont.stop_loss != 0">
              <div class="t1">{{$t('zyzs.zs')}}</div>
              <div class="t2">{{pcCont.stop_loss}}</div>
            </li>
            <li class="select" v-show="tabIdx != 1">
              <div class="t1">{{$t('hyjy.bzjl')}}</div>
              <div class="t2">{{pcCont.margin | toFixed4}}</div>
            </li>
            <li class="select" v-show="tabIdx == 0">
              <div class="t1">{{$t('hyjy.ccsj')}}</div>
              <div class="t2">{{pcCont.position_time}}</div>
            </li>
            <li class="select" v-show="tabIdx == 1">
              <div class="t1">{{$t('langNew.gdsj')}}</div>
              <div class="t2">{{pcCont.time}}</div>
            </li>
            <li class="select" v-show="tabIdx == 2">
              <div class="t1">{{$t('deals.pgtime')}}</div>
              <div class="t2">{{pcCont.close_out_time}}</div>
            </li>
          </ul>
          <div class="btn btn-bg" @click="close">{{$t('langNew.zdl')}}</div>
        </div>
        <!-- 平仓弹窗 -->
        <div class="alert-pc-box" v-show="isPc">
          <div class="title">
              {{$t('hyjy.pc')}}
              <img class="close" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <div class="alert-item-box">
              <div><span class="title">{{pcCont.currency | rewriteName}}</span><span class="buy" v-if="pcCont.type == 1">{{$t('kxt.mr')}}</span><span class="buy" v-if="pcCont.type == 2">{{$t('kxt.mc')}}</span><span class="lot">{{pcCont.position_a}} {{$t('langNew.shou')}}</span></div>
              <ul class="ul-box">
                  <li class="li">
                    <div class="t1 price">USD<span v-show="pcCont.profit_loss > 0">+</span>{{pcCont.profit_loss | toFixed4}}</div>
                    <div class="t2">{{$t('langNew.fdjyk')}}</div>
                  </li>
                  <li class="li text-center">
                      <div class="t1">{{pcCont.open_price}}</div>
                      <div class="t2">{{$t('hyjy.kcjg')}}</div>
                  </li>
                  <li class="li text-right">
                      <div class="t1">{{pcCont.new_price}}</div>
                      <div class="t2">{{$t('langNew.dqjg')}}</div>
                  </li>
              </ul>
          </div>
          <div class="tips">{{$t('langNew.pcsl')}}</div>
          <div class="num-box">
              <img class="icon" src="@/assets/new/jian.png" @click="num(-1,pcCont.position_a)" alt="">
              <div>
                  <div class="t1"><input class="number" type="text" v-model="number" @keyup="keyMoney2"> <div>{{$t('langNew.shou')}}</div></div>
                  <div class="t2">{{$t('langNew.ksrfw')}} 0-{{pcCont.position_a}}</div>
              </div>
                  <img class="icon" src="@/assets/new/jia2.png" @click="num(1,pcCont.position_a)" alt="">
          </div>
          <div class="btn-sure btn-bg" @click="pcSure(pcCont)">{{$t('langNew.qrpc')}}</div>
        </div>
        <!-- 筛选 -->
        <div class="alert-select-box3" v-show="isSelect">
          <div class="title">
            {{$t('langNew.sx')}}
            <img class="close" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <ul class="select-ul">
            <li class="tips">{{$t('bzxz.title')}}</li>
            <li class="select" @click="changeBz(item.currency)" v-for="(item,index) in currencyList" :key="index">
              <div class="select-left">
                <div class="coin">{{item.currency | rewriteName}}</div>
              </div>
              <img class="arrow" v-show="curCurrency == item.currency" src="@/assets/new/tick.png" alt="">
            </li>
          </ul>
          <div class="btn-box">
            <div class="btn" @click="reset">{{$t('langNew.cz')}}</div>
            <div class="btn" @click="sure">{{$t('sztkmm.qd')}}</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contractOrder',
    data () {
        return {
          theme: false,
          isMask: false,
          tabIdx: 0,
          isSelect: false,
          currencyArr: [],
          isDetail: false,
          isPc: false,
          number: '',
          currency: '',
          wt: 13,//挂单
          type: 2,
          positionList: [],
          currencyList: [],
          pcCont: {},
          curCurrency: '',
          isNoData: false,
          isGoTOP: false,
          page: 1,
          limit: 10,
          curDataLength: 10
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      this.getmarketList();
      // this.getPositionList();
    },
    methods: {
      back(){
        this.$router.push('/preciousMetal')
      },
      setZyzs(item){
        localStorage.setItem('szzyzsInfo',JSON.stringify(item));
        this.$router.push('/setProfit')
      },
      close(){
        this.isMask = this.isSelect = this.isDetail = this.isPc = false;
      },
      select(){
        this.isMask = this.isSelect = true;
      },
      tab(idx){
        this.tabIdx = idx;
        this.page = 1;
        this.positionList = [];
        this.getPositionList();
      },
      initWebSocket(){ //初始化weosocket
          const wsuri = this.socket_url;
          this.websock = new WebSocket(wsuri);
          this.websock.onmessage = this.websocketonmessage;
          this.websock.onopen = this.websocketonopen;
          this.websock.onerror = this.websocketonerror;
          this.websock.onclose = this.websocketclose;
      },
      websocketonopen(){ //连接建立之后执行send方法发送数据
      },
      websocketonerror(){//连接建立失败重连
          this.initWebSocket();
      },
      websocketonmessage(e){ //数据接收
        let msg = JSON.parse(e.data).content;
        if(JSON.parse(e.data).action == "marketprice"){
          if(this.positionList){
            var newArr = this.positionList.map(item =>{
              if(msg[item.currency]){
                var obj = {cur_price: msg[item.currency].now_price};
                item = { ...item,...obj };
              }else{
                var obj = {cur_price: 0};
                item = { ...item,...obj };
              }
              return item
            });
          }
          this.positionList = newArr;
        }
      },
      websocketsend(Data){//数据发送
          this.websock.send(Data);
      },
      websocketclose(e){  //关闭
          // console.log('断开连接',e);
      },
      getmarketList() {
        var that = this;
        let params = {
            type: 2,
            token: '',
            id: 1,
            classify: 0
        }
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          that.currencyList = resData;
          // that.curCurrency = resData[0].currency;
          that.getmarketList2();
          that.getPositionList();
        }).catch(function(err){
            console.log(err)
        })
      },
      getmarketList2() {
        var that = this;
        let params = {
            type: 3,
            token: '',
            id: 1,
            classify: 0
        }
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          that.currencyList = that.currencyList.concat(resData);
        }).catch(function(err){
            console.log(err)
        })
      },
      changeBz(text){
        this.curCurrency = text;
      },
      sure(){
        this.isMask = this.isSelect = false;
        this.positionList = [];
        this.page = 1;
        this.getPositionList();
      },
      reset(){
        this.curCurrency = this.currencyList[0].currency;
      },
      look(item){
        this.isDetail = this.isMask = true;
        this.pcCont = item;
      },
      pingcang(item){//平仓弹窗
        this.isMask = this.isPc = true;
        this.pcCont = item;
        this.number = item.position_a;
      },
      pcSure(item){//确认平仓
        let that = this;
        // var type = item.type ==1 ? 4 : 3
        let params = {
          id: item.id
          // amount: that.number,
          // mark: type,
          // currency: item.currency,
        }
        this.$ajax.post('/web/closePosition',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                that.$toast.center(resData.message);
                that.isPc = false;
                that.isMask = false;
                that.page = 1;
                that.positionList = [];
                that.getPositionList();
            }else{
                this.$toast.center(resData.message);
                return;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      cancelOrder(id){//撤单
        var that = this;
        let params = {
          id: id
        }
        this.$ajax.post('/web/orderCancel',params).then((res) => {
          let resData = res.data;
          that.$toast.center(resData.message);
          that.page = 1;
          that.positionList = [];
          that.getPositionList();
        }).catch(function(err){
            console.log(err)
        })
      },
      getPositionList(){//持仓记录
        let that = this;
        if(this.tabIdx != 1){
          var params = {
            currency: that.currency,
            is_pl_r: 1,
            page: that.page
          }
          var url = this.tabIdx == 0 ? '/web/getPositionList' : '/web/getClosePositionList'
        }else{
          var params = {
            currency: that.currency,
            type: that.type,
            wt: that.wt,
            limit: that.limit,
            page: that.page
          }
          var url = 'web/getWeiTuo'
        }
        this.$ajax.get(url,{params}).then((res) => {
            let resData = res.data.data;
            if(resData.list.length > 0){
              that.positionList = that.positionList.concat(resData.list);
              that.curDataLength = resData.list.length;
              that.initWebSocket();
            }else{
              that.curDataLength = resData.list.length;
            }
            if(that.positionList.length > 0){
                that.isNoData = false;
            }else{
                that.isNoData = true;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      getWeiTuo(){
          let that = this;
          let params = {
              currency: that.currency,
              type: that.type,
              wt: that.wt,
              limit: that.limit,
              page: that.page
          }
          this.$ajax.get('/web/getWeiTuo',{params}).then((res) => {
              let resData = res.data.data;
              if(resData.list.length > 0){
                  that.wetTuoData = that.wetTuoData.concat(resData.list);
                  that.curDataLength = resData.list.length;
              }else{
                  that.curDataLength = resData.list.length;
              }
              if(that.wetTuoData.length > 0){
                  that.isNoData = false;
              }else{
                  that.isNoData = true;
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      listenScroll(e) {  //监听滚动
          let ele = e.srcElement ? e.srcElement : e.target;
          if(ele.scrollTop > 200){
              this.isGoTOP = true
          }else{
              this.isGoTOP = false
          }
          if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
            if(this.curDataLength >= this.limit){
              this.page ++;
              this.getPositionList();
            }
          }
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      },
      num(id,max){
        if(id < 0){
          if(parseFloat(this.number) > 1){
            this.number = (parseFloat(this.number) -1).toFixed(4)
          }
        }else{
          if(parseFloat(this.number) < parseFloat(max)){
          this.number = (parseFloat(this.number) +1).toFixed(4);
          }else{
            this.number = parseFloat(max).toFixed(4)
          }
        }
      },
      keyMoney2(){
        this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
            this.number = parseFloat(this.number);
        }
      },
    },
    watch: {
      number:function(val){
        if(val >= parseFloat(this.pcCont.position_a)){
          this.number = parseFloat(this.pcCont.position_a);
        }else{
          this.number = val;
        }
      }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .contractOrder{
    background: #f3f4f6;
  }
  .head{
      position: fixed;
      top: 0;
      width: 100%;
      height: 1.6rem;
      padding: 0 .44rem;
      color: #000;
      line-height: 1.6rem;
      background: #f3f4f6;
      box-sizing: border-box;
      text-align: center;
  }
  .head .back{
      position: absolute;
      left: .4rem;
      top: 50%;
      width: .4rem;
      margin-top: -.4rem;
  }
  .head .title{
      font-size: .56rem;
  }
  .head .search{
    position: absolute;
    right: .5rem;
    width: .5rem;
    top: 50%;
    margin-top: -.25rem;
  }
  .cotainer{
      position: absolute;
      top: 3.34rem;
      bottom: 0;
      width: 100%;
      background: #f3f4f6;
      overflow-y: scroll;
  }
  .tab-wrap{
    position: absolute;
    top: 2.34rem;
    left: .68rem;
    right: .68rem;
  }
  .tab-box{
    display: flex;
    justify-content: space-around;
    align-items: center;
    align-content: center;
    flex-wrap: nowrap;
    width: 100%;
    overflow-x: scroll;
  }
  .tab-box::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .tab-box .tab{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 33.33%;
    height: 0.98rem;
    padding: 0 .1rem;
    color: #000;
    font-size: .42rem;
    white-space: nowrap;
    box-sizing: border-box;
    background-color: #efefef;
    border-radius: 0.48rem 0rem 0rem 0.48rem;
    border: solid 0.01rem #b1b1b1;
    box-sizing: border-box;
    text-align: center;
  }
  .tab-box .tab:last-child{
    margin-right: 0;
  }
  .tab-box .tab.active{
      color: #fff !important;
      white-space: nowrap;
      background-color: #4458ed!important;
      border-radius: 0.48rem 0rem 0rem 0.48rem;
      border: solid 0.01rem #b1b1b1;
  }
  .tab-box .tab2{
    border-radius: 0;
    background-color: #efefef;
    border-top: solid 0.01rem #b1b1b1;
    border-bottom: solid 0.01rem #b1b1b1;
  }
  .tab-box .tab2.active{
    background-color: #4458ed;
    border-radius: 0;
    border-top: solid 0.01rem #b1b1b1;
    border-bottom: solid 0.01rem #b1b1b1;
  }
  .tab-box .tab3{
    border-radius: 0 .48rem .48rem 0;
  }
  .tab-box .tab3.active{
    background-color: #4458ed;
    border-radius: 0 .48rem .48rem 0;
    border: solid 0.01rem #b1b1b1;
  }
  .cotainer .item-box{
    padding: .64rem .45rem;
  }
  .cotainer .item-box .item-li{
      padding: .6rem .48rem .8rem;
      margin-bottom: .4rem;
      background: #fff;
      border-radius: .3rem;
      box-sizing: border-box;
    }
    .cotainer .item-box .item-li .ul-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cotainer .item-box .item-li .li-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cotainer .item-box .item-li .title{
      color: #000;
      font-size: .42rem;
    }
    .cotainer .item-box .item-li .bei{
      display: inline-block;
      margin: 0 .15rem 0 .3rem;
      padding: .14rem .2rem;
      color: #2d66cf;
      font-size: .34rem;
      background: #1b2a42;
	    border-radius: 0.1rem;
    }
    .cotainer .item-box .item-li .ul-box .li{
      margin-top: .34rem;
    }
    .cotainer .item-box .item-li .ul-box .li.li-lt .t2{
      display: flex;
      align-items: stretch;
      flex: 1
    }
    .cotainer .item-box .item-li .ul-box .li.li-lt .icon{
      width: .5rem;
      height: .3rem;
      margin: .1rem .4rem 0;
    }
    .cotainer .item-box .item-li .ul-box .li.li-lt .money{
      color: #000;
      font-size: .42rem;
    }
     .cotainer .item-box .item-li .ul-box .li.li-lt .text{
       padding-top: .32rem;
       color: #909090;
       font-size: .36rem;
     }
    .cotainer .item-box .item-li .ul-box .li3{
      margin-right: .2rem;
    }
    .cotainer .item-box .item-li .ul-box .li:last-child{
      margin-right: 0;
    }
    .cotainer .item-box .item-li .ul-box .t1{
      color: #00a94c;
      font-size: .48rem;
    }
    .cotainer .item-box .item-li .ul-box .t2{
      margin-top: .34rem;
      color: #909090;
      font-size: .34rem;
    }
    .cotainer .item-box .item-li .btn-pc{
      padding: .16rem .53rem;
      color: #000;
      font-size: .34rem;
      word-break: keep-all;
      background: #fff;
      border-radius: 0.24rem;
    }
    .cotainer .item-box .item-li .pc-price{
        color: #c62542;
        font-size: .48rem;
    }
    /* 详情 */
    .alert-select-box2{
      position: absolute;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      padding: 0 .62rem .84rem;
      border-radius: .4rem .4rem 0 0;
      background: #fff;
      box-sizing: border-box;
    }
    .alert-select-box2 .title{
      position: relative;
      margin-bottom: .2rem;
      padding: .74rem 0;
      text-align: center;
    }
    .alert-select-box2 .title .title-head{
      display: flex;
      justify-content: center;
      align-items: center;
      color: #1cb460;
      font-size: .56rem;
    }
    .alert-select-box2 .title .title-head .icon{
      width: .68rem;
      margin-right: .36rem;
    }
    .alert-select-box2 .close{
      position: absolute;
      right: 0;
      top: 50%;
      width: .72rem;
      transform: translateY(-50%);
    }
    .alert-select-box2 .select-ul{
      max-height: 350px;
      overflow-y: scroll;
    }
    .alert-select-box2 .select{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: .68rem;
    }
    .alert-select-box2 .select .t1{
      color: #646464;
      font-size: .38rem;
    }
    .alert-select-box2 .select .t2{
      color: #000;
      font-size: .42rem;
    }
    .alert-select-box2 .select .arrow{
      width: .18rem;
    }
     .alert-select-box2 .select .t2.price{
       color: #00a94c;
     }
     .alert-select-box2 .select .t2 .arrow{
       width: .42rem;
     }
    .alert-select-box2 .bei{
      display: inline-block;
      margin-left: .26rem;
      padding: .16rem .26rem;
      color: #2d66cf;
      font-size: .34rem;
      background: #dfeaff;
	    border-radius: 0.1rem;
    }
    .alert-select-box2 .btn{
      margin-top: .9rem;
      background: #0060ff;
    }
    /* 筛选 */
    .alert-select-box3{
      position: absolute;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      padding: 0 .62rem .84rem;
      border-radius: .4rem .4rem 0 0;
      background: #fff;
      box-sizing: border-box;
    }
    .alert-select-box3 .title{
      position: relative;
      margin-bottom: .96rem;
      padding: .74rem 0 0;
      color: #000;
      font-size: .56rem;
      text-align: center;
    }
    .alert-select-box3 .close{
      position: absolute;
      right: 0;
      top: 50%;
      width: .72rem;
      transform: translateY(-50%);
    }
    .alert-select-box3 .select-ul{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: wrap;
      max-height: 300px;
      padding-bottom: .3rem;
      overflow-y: scroll;
    }
    .alert-select-box3 .select-ul2{
      display: block;
    }
    .alert-select-box3 .select-ul .tips{
      width: 100%;
      color: #000;
      font-size: .48rem;
      margin: .4rem 0 .1rem;
    }
    .alert-select-box3 .select-ul .select{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 3.5rem;
      margin: .4rem .1rem .3rem 0;
      padding: .42rem .56rem;
      border-radius: .2rem;
      background: #f3f5fa;
    }
    .alert-select-box3 .select-ul2 .select{
      width: auto;
      margin: 0 0 .64rem;
    }
    .alert-select-box3 .select-ul .icon{
      width: .96rem;
    }
    .alert-select-box3 .select-ul .coin{
      padding-left: .48rem;
      color: #000;
      font-size: .42rem;
    }
    .alert-select-box3 .arrow{
      width: .58rem;
    }
    .alert-select-box3 .time-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .alert-select-box3 .time-box .time{
      width: 3.5rem;
      padding: .42rem .56rem;
      color: #000;
      font-size: .42rem;
      border-radius: 0.07rem;
      background: #f3f5fa;
      text-align: center;
    }
    .alert-select-box3 .btn-box{
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .alert-select-box3 .btn-box .btn{
      width: 4rem;
      padding: .4rem 0;
      color: #fff;
      font-size: .42rem;
      border-radius: .2rem;
      background: #4458ed;
      text-align: center;
    }
    /* 平仓 */
    .alert-pc-box{
        position: fixed;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        padding: .62rem .62rem .8rem;
        border-radius: .4rem .4rem 0 0;
        background: #fff;
        box-sizing: border-box;
    }
    .alert-pc-box .title{
        position: relative;
        color: #000;
        font-size: .56rem;
        text-align: center;
    }
    .alert-pc-box .close{
        position: absolute;
        top: 50%;
        right: 0;
        width: .74rem;
        transform: translateY(-50%);
    }
    .alert-pc-box .alert-item-box{
        margin-top: .8rem;
        padding: .5rem .42rem .58rem;
        border-radius: 0.3rem;
	    border: 1px solid #d9d9d9
    }
    .alert-pc-box .alert-item-box .title{
        color: #000;
        font-size: .42rem;
    }
    .alert-pc-box .alert-item-box .buy{
        display: inline-block;
        margin: 0 .12rem 0 .2rem;
        padding: .14rem .32rem;
        color: #c62542;
        font-size: .34rem;
        background: #ffe4e9;
        border-radius: .1rem;
    }
    .alert-pc-box .alert-item-box .bei{
        display: inline-block;
        margin: 0 .12rem 0 0;
        padding: .14rem .32rem;
        color: #2d66cf;
        font-size: .34rem;
        background: #dfeaff;
        border-radius: .1rem;
    }
    .alert-pc-box .alert-item-box .lot{
        color: #878789;
        font-size: .34rem;
    }
    .alert-pc-box .alert-item-box .ul-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .78rem;
    }
    .alert-pc-box .alert-item-box .t1{
        color: #000;
        font-size: .4rem;
    }
    .alert-pc-box .alert-item-box .t1.price{
        color: #00a94c;
    }
    .alert-pc-box .alert-item-box .t2{
        padding-top: .34rem;
        color: #909090;
        font-size: .34rem;
    }
    .alert-pc-box .tips{
        padding: .4rem 0 .32rem;
        color: #686868;
        font-size: .34rem;
    }
    .alert-pc-box .num-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem .56rem;
        background: #f3f5fa;
	    border-radius: 0.3rem;
    }
    .alert-pc-box .num-box .icon{
        width: .5rem;
    }
    .alert-pc-box .num-box .t1{
      display: flex;
      align-items: center;
        color: #000;
        font-size: .48rem;
        text-align: center;
    }
    .alert-pc-box .num-box .t1 .number{
      width: 2.2rem;
      text-align: center;
    }
    .alert-pc-box .num-box .t2{
        color: #686868;
        font-size: .3rem;
        text-align: center;
    }
    .alert-pc-box .btn-sure{
        margin-top: .7rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/contractOrder.vue